<script setup>
import { computed } from 'vue'
import { Tag } from '@aryeo/runway'

import ListingDeliveryStatus from '@/Utils/Listings/ListingDeliveryStatus.js'

const props = defineProps({
  deliveryStatus: {
    type: String,
    required: true,
  },
  isSmall: {
    type: Boolean,
    default: false,
  },
})

const deliveryStatusOption = computed(() => {
  return Object.values(ListingDeliveryStatus).find(
    (status) => status.value === props.deliveryStatus.toLowerCase()
  )
})

const color = computed(() => {
  return deliveryStatusOption.value?.color ?? 'secondary'
})
</script>

<template>
  <Tag :label="deliveryStatusOption?.name ?? 'No Status'" :color="color" :isSmall="isSmall" />
</template>
